import userFamilyApi from "@/api/family-api";

const userFamilyRoles = {
  state: {
    userFamilyRolesData: {}
  },
  actions: {
    async setUserFamilyRoles({ commit }) {
      const response = await userFamilyApi.getFamilyRoles();
      if (response.data.data.userFamilyRoles) {
        commit("SET_UserFamilyRoles", response.data.data.userFamilyRoles);
      }
    },
  },
  mutations: {
    SET_UserFamilyRoles(state, userFamilyRolesData) {
      state.userFamilyRolesData = userFamilyRolesData;
    },
  },
  getters: {
    getuserFamilyRoles: (state) => state.userFamilyRolesData,
  }
}

export default userFamilyRoles
